(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2268],{

/***/ 1373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/shared/src/utils.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/Icon.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const Icon = (0,react.forwardRef)(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => {
    return (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: mergeClasses("lucide", className),
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    );
  }
);


//# sourceMappingURL=Icon.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ className, ...props }, ref) => (0,react.createElement)(Icon, {
      ref,
      iconNode,
      className: mergeClasses(`lucide-${toKebabCase(iconName)}`, className),
      ...props
    })
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ 8909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Briefcase; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Briefcase = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Briefcase", [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);


//# sourceMappingURL=briefcase.js.map


/***/ }),

/***/ 6309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Building2; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Building2 = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Building2", [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);


//# sourceMappingURL=building-2.js.map


/***/ }),

/***/ 5058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChartNoAxesColumn; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChartNoAxesColumn = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ChartNoAxesColumn", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
]);


//# sourceMappingURL=chart-no-axes-column.js.map


/***/ }),

/***/ 9242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Eye; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Eye = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);


//# sourceMappingURL=eye.js.map


/***/ }),

/***/ 3766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FileText; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const FileText = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("FileText", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);


//# sourceMappingURL=file-text.js.map


/***/ }),

/***/ 5977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Lock; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Lock = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Lock", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);


//# sourceMappingURL=lock.js.map


/***/ }),

/***/ 443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Server; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Server = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Server", [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
]);


//# sourceMappingURL=server.js.map


/***/ }),

/***/ 9455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Shield; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Shield = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);


//# sourceMappingURL=shield.js.map


/***/ }),

/***/ 9461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Zap; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Zap = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);


//# sourceMappingURL=zap.js.map


/***/ }),

/***/ 1761:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/analytics-ai-automation",
      function () {
        return __webpack_require__(3304);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MethodologyAnchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var steps = [
    {
        step: "01",
        title: "Discovery sprint",
        desc: "2 weeks, fixed price. We scope the problem, audit your data, and produce a written roadmap, cost estimate, and risk register. You decide whether to proceed — no commitment beyond the sprint."
    },
    {
        step: "02",
        title: "Build",
        desc: "Fixed-scope first phase or time-and-materials with a cap. Production-grade code, not a prototype. Delivered into your cloud environment with tests, monitoring, and handoff documentation."
    },
    {
        step: "03",
        title: "Operate",
        desc: "4–8 week warranty period post-handoff. Bugs and regressions fixed at zero cost. Ongoing ops available — we don't disappear after delivery."
    }, 
];
function MethodologyAnchor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-5xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-2",
                    children: "How an engagement works"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-gray-500 mb-10 text-base",
                    children: "No open-ended retainers. Every engagement starts with a bounded, fixed-price discovery."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-8",
                    children: steps.map(function(s) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-bold text-[#f1aa4e]",
                                    children: s.step
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-600 text-sm leading-relaxed",
                                    children: s.desc
                                })
                            ]
                        }, s.step);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/itmtb-how-we-work",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "text-blue-600 font-semibold text-sm hover:underline",
                            children: "Full methodology and engagement shapes →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 3304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ analytics_ai_automation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/blogUtils.js
var blogUtils = __webpack_require__(1180);
// EXTERNAL MODULE: ./blogs.json
var blogs = __webpack_require__(2684);
// EXTERNAL MODULE: ./components/services/Service2.js
var Service2 = __webpack_require__(3230);
// EXTERNAL MODULE: ./components/trust/SuccessStoryEmbed.js
var SuccessStoryEmbed = __webpack_require__(2100);
// EXTERNAL MODULE: ./components/services/MethodologyAnchor.js
var MethodologyAnchor = __webpack_require__(710);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/services/ServiceFAQ.js
var ServiceFAQ = __webpack_require__(2616);
// EXTERNAL MODULE: ./components/services/ServiceEngagementLinks.js
var ServiceEngagementLinks = __webpack_require__(5733);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/zap.js
var zap = __webpack_require__(9461);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/shield.js
var shield = __webpack_require__(9455);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/eye.js
var eye = __webpack_require__(9242);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/lock.js
var lock = __webpack_require__(5977);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/building-2.js
var building_2 = __webpack_require__(6309);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/server.js
var server = __webpack_require__(443);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chart-no-axes-column.js
var chart_no_axes_column = __webpack_require__(5058);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/file-text.js
var file_text = __webpack_require__(3766);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/briefcase.js
var briefcase = __webpack_require__(8909);
;// CONCATENATED MODULE: ./components/services/OrchestriкSection.js



var benefits = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(zap/* default */.Z, {
            size: 20
        }),
        title: "Faster delivery",
        desc: "Pre-built orchestration, monitoring, and security layers mean your project doesn't start from zero — typical timelines shrink by weeks."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(shield/* default */.Z, {
            size: 20
        }),
        title: "Production-hardened from day one",
        desc: "Orchestrik has been tested in live enterprise deployments. Infrastructure problems are already solved before we start on yours."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(eye/* default */.Z, {
            size: 20
        }),
        title: "Built-in observability",
        desc: "Every agent action is logged. You get full visibility into what your agents are doing, when, and why — without custom instrumentation work."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(lock/* default */.Z, {
            size: 20
        }),
        title: "Security and access controls included",
        desc: "Role-based access, audit trails, and data residency controls are part of the platform — not add-ons scoped after the fact."
    }, 
];
var industries = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(building_2/* default */.Z, {
            size: 18
        }),
        label: "Financial Services",
        href: "/industry/banking"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(server/* default */.Z, {
            size: 18
        }),
        label: "Supply Chain & Logistics",
        href: "/industry/supply-chain"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chart_no_axes_column/* default */.Z, {
            size: 18
        }),
        label: "Retail & D2C",
        href: "/industry/retail"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(file_text/* default */.Z, {
            size: 18
        }),
        label: "Life Sciences & Pharma",
        href: "/industry/life-sciences"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(briefcase/* default */.Z, {
            size: 18
        }),
        label: "Management Consulting",
        href: "/services/strategy"
    }, 
];
function OrchestriкSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "px-8 md:px-[60px] py-14 bg-[#0f1f3d]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-5xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-xs font-semibold uppercase tracking-widest text-blue-400 mb-4",
                    children: "Our platform"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-white mb-4 leading-snug",
                    children: "We build on Orchestrik — our own AI agent platform"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-gray-300 text-base md:text-lg mb-10 max-w-2xl leading-relaxed",
                    children: "Most AI projects spend the first months building infrastructure before writing a single line of business logic. We don't. Orchestrik is the platform we built for ourselves and run every client engagement on — so you skip straight to the part that matters."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-7 mb-12",
                    children: benefits.map(function(b) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-shrink-0 mt-0.5 text-blue-400",
                                    children: b.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-white font-semibold text-sm mb-1",
                                            children: b.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-gray-400 text-sm leading-relaxed",
                                            children: b.desc
                                        })
                                    ]
                                })
                            ]
                        }, b.title);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/orchestrik",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "inline-block bg-white text-[#0f1f3d] font-semibold text-sm px-6 py-3 rounded-md hover:bg-gray-100 transition-colors mb-12",
                        children: "Know More →"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border-t border-white/10 pt-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-500 mb-5",
                            children: "Deployed across industries"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-wrap gap-3",
                            children: industries.map(function(ind) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: ind.href,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "inline-flex items-center gap-2 border border-white/10 rounded-full px-4 py-2 text-sm text-gray-300 hover:border-blue-400 hover:text-blue-300 transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-blue-400",
                                                children: ind.icon
                                            }),
                                            ind.label
                                        ]
                                    })
                                }, ind.label);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/ai-agent-demo/CustomerSection.js
var CustomerSection = __webpack_require__(4837);
;// CONCATENATED MODULE: ./pages/services/analytics-ai-automation.js







var Capabilities2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(9134)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});







var ContactUsHome = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6245).then(__webpack_require__.bind(__webpack_require__, 6245));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6245)
            ];
        }
    },
    ssr: false
});
var Footer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
Analyticsaiautomation.title = "AI & Analytics Consulting: Built, Not Advised | ITMTB";
Analyticsaiautomation.desc = "Enterprise AI agents built, deployed, and operated in production, not slide decks. Proven analytics and automation: 99% faster lookups across 100,000+ SKUs.";
Analyticsaiautomation.header_img = "https://www.itmtb.com/services/capability/data.webp";
Analyticsaiautomation.keywords = "AI agent deployment, enterprise AI consulting, agentic AI implementation, AI automation services, analytics consulting, LLM deployment enterprise, machine learning solutions, AI-driven automation, intelligent automation solutions";
var faqItems = [
    {
        q: "What is an AI agent deployment partner?",
        a: "An AI agent deployment partner scopes, builds, deploys, and operates AI agents for enterprise workflows — end to end. This is different from an 'AI consultant' who advises but doesn't build, and different from a product vendor who sells a licensed platform. ITMTB designs the architecture (model selection, orchestration framework, tool integration), builds the production system (using technologies like LangChain, LlamaIndex, GPT-4, Claude, and RAG pipelines), deploys it into your infrastructure, and operates it post-launch. The output is a running AI system in your environment, not a slide deck or a SaaS subscription."
    },
    {
        q: "What AI use cases deliver the fastest ROI?",
        a: "Based on ITMTB's delivery experience, the use cases with the fastest return are: (1) Document and data processing automation — invoices, contracts, reports that currently require manual review. (2) Supply chain pattern matching and lookup — we delivered a 99% efficiency gain for a global supply chain leader managing 100,000+ SKUs, reducing lookup time from hours to under 3 minutes. (3) Risk and compliance report generation — fully automated third-party risk reports for a global intelligence firm, replacing hours of analyst work per report. (4) Customer-service and internal-support agents — handling tier-1 queries with tool-calling agents that reach into live systems. These use cases share a common trait: there is a well-defined, high-volume manual process with structured-enough data to give an agent reliable inputs."
    },
    {
        q: "How long does an AI project take from scoping to production?",
        a: "ITMTB engagements follow a fixed shape. Discovery sprint: 2 weeks — we scope the problem, estimate cost and timeline, and identify technical and data risks. You receive a written roadmap and risk register before committing to the build. MVP build: 4 to 8 weeks, depending on integration complexity and data readiness. Production deployment: 8 to 16 weeks for full production-grade systems including testing, monitoring, and handoff. Total calendar time from first conversation to a live production system typically runs 12 to 20 weeks. The primary variable is data readiness — teams with clean, accessible data move faster."
    },
    {
        q: "How do you handle AI hallucination and reliability in production?",
        a: "This is the right question to ask before choosing a build partner. Our production AI systems use four layers of reliability: (1) Retrieval-Augmented Generation (RAG) — the agent retrieves facts from a controlled, versioned knowledge base rather than relying on model memory, which eliminates whole classes of hallucination. (2) Output validation — structured output schemas, constraint checking, and deterministic guard rails on every agent response. (3) Human-in-the-loop escalation — for high-stakes decisions, agents are designed to escalate to a human reviewer rather than auto-act when confidence is below threshold. (4) Monitoring and regression testing — production agents are monitored for output drift, prompt injection attempts, and latency degradation. Reliability in production is an architecture decision, not a tuning afterthought."
    },
    {
        q: "How do you handle data privacy and compliance in enterprise AI projects?",
        a: "Compliance is scoped in the discovery sprint — not retrofitted. For every engagement we document data flows, identify which data categories are processed by the AI system, and design the appropriate controls: data residency within the required region, PII segregation and access logging, consent management where needed, and audit trails for AI decisions that can be produced for a regulatory or internal review. We have delivered AI systems for clients operating under financial services regulations, data protection laws, and enterprise information security policies. The specific controls depend on your jurisdiction and data category — we identify them during discovery."
    },
    {
        q: "How does ITMTB price an engagement?",
        a: "Pricing follows the engagement model. Discovery sprints are fixed-price for a fixed timebox. Build engagements are scoped after discovery — fixed-scope, time-and-materials, or outcome-linked. Managed services are billed monthly with defined SLAs. Total cost depends on scope, integration complexity, QA depth, and post-launch support — we publish a transparent breakdown for buyers evaluating their options.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
Analyticsaiautomation.faq = faqItems;
function Analyticsaiautomation() {
    var insights;
    var caseStudies;
    var aiInsights = (0,_to_consumable_array/* default */.Z)(blogs).filter(function(item) {
        var ref, ref1, ref2;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Data and Artificial Intelligence")) && ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref2 = item.meta) === null || ref2 === void 0 ? void 0 : ref2.category);
    });
    var aiCaseStudies = (0,_to_consumable_array/* default */.Z)(blogs).filter(function(item) {
        var ref, ref1, ref2;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Data and Artificial Intelligence")) && (item === null || item === void 0 ? void 0 : (ref2 = item.meta) === null || ref2 === void 0 ? void 0 : ref2.category) === "case-study";
    });
    if (aiInsights.length >= 2) {
        insights = (0,blogUtils/* getRandom */.s)(aiInsights, 2);
    } else if (aiInsights.length === 1) {
        insights = (0,_to_consumable_array/* default */.Z)(aiInsights).concat((0,_to_consumable_array/* default */.Z)((0,blogUtils/* getRandom */.s)((0,_to_consumable_array/* default */.Z)(blogs).filter(function(item) {
            var ref;
            return ![
                "case-study",
                "tech"
            ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) && !aiInsights.includes(item);
        }), 1)));
    } else {
        insights = (0,blogUtils/* getRandom */.s)((0,_to_consumable_array/* default */.Z)(blogs).filter(function(item) {
            var ref;
            return ![
                "case-study",
                "tech"
            ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
        }), 2);
    }
    if (aiCaseStudies.length >= 2) {
        caseStudies = (0,blogUtils/* getRandom */.s)(aiCaseStudies, 2);
    } else {
        caseStudies = (0,blogUtils/* getRandom */.s)((0,_to_consumable_array/* default */.Z)(blogs).filter(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
        }), 2);
    }
    var subServices = [
        {
            img: null,
            key: "Not sure where AI fits? Start with a strategy session.",
            title: "A focused 2-week engagement that tells you exactly what AI can do for your operations — and what it can't.",
            text: "Before committing to a build, you walk away with a clear picture: which workflows are worth automating, a realistic cost and timeline, and a written risk register. Fixed scope, fixed price. No open-ended retainer, no obligation to proceed.\n\n<a href='/contact-us' style='color:#93c5fd;font-weight:600;text-decoration:underline;'>Talk to us →</a>"
        },
        {
            img: null,
            key: "AI Agents That Run Your Workflows End to End",
            title: "Your team stops managing the process. The agent handles approvals, lookups, decisions, and notifications — autonomously.",
            text: "Think of the workflows your team coordinates manually today: gathering approvals, pulling data from multiple systems, routing tasks, sending updates. An AI agent can run the entire sequence — acting on live data, following your business rules, and escalating to a human only when it genuinely needs to.\n\nWe design and build these agents to fit your existing systems and processes. No rip-and-replace. The agent connects to what you already have."
        },
        {
            img: null,
            key: "Secure, Auditable, and Compliant Deployments",
            title: "Every AI decision is logged, every access is controlled, and every deployment can run in your own environment.",
            text: "Enterprise AI must meet the same standards as any other production system — and usually higher ones. We build in role-based access controls, full audit trails for every agent decision, data residency within your required region, and PII segregation from the start.\n\nFor organisations that cannot send data to third-party cloud services, we also support on-premises and private cloud deployments. Compliance requirements are scoped in the discovery sprint — not retrofitted after the fact."
        },
        {
            img: null,
            key: "Works With What You Already Have",
            title: "Your AI agents connect to your ERP, CRM, databases, and legacy systems — not a separate data island.",
            text: "The biggest risk in any AI project is building something that can't reach your real operational data. We spend time upfront mapping your systems — whether that's SAP, Dynamics 365, Salesforce, a proprietary database, or a set of internal APIs — and designing the integration layer so agents can act on live, accurate information.\n\nIf a legacy system doesn't have an API, we've built bridges before. Your AI investment should work with your existing technology, not require you to replace it."
        },
        {
            img: null,
            key: "24\xd77 Agent Operations and Support",
            title: "We don't disappear after deployment. Your agents are monitored, maintained, and supported around the clock.",
            text: "Running AI agents in production is different from running traditional software. Model drift, prompt injection risks, API dependency changes, and inference cost spikes all require specialist ops. We provide:\n\n• 24\xd77 availability monitoring with alerting\n• Incident response SLA for production issues\n• Regular model performance reviews and prompt regression testing\n• A warranty period post-handoff — bugs and regressions fixed at zero cost\n\nYou get a system that stays reliable, not one you have to babysit."
        },
        {
            img: null,
            key: "Accurate AI Starts With Reliable Data",
            title: "An AI that sees bad data makes confident mistakes. We make sure yours never does.",
            text: "Before any agent goes live, we audit and fix the data it will rely on. That means pipelines that pull from your source systems, clean and structure the data correctly, and keep it fresh as your business changes.\n\nWe also build monitoring so that if data quality degrades — a schema change, a broken feed, a missing field — you find out before your AI does."
        },
        {
            img: null,
            key: "Multi-Agent Systems for Complex Processes",
            title: "When one agent isn't enough — we build systems where multiple specialized agents coordinate, hand off, and escalate.",
            text: "Some business processes are too complex for a single agent: they require specialist judgment at different stages, approvals from multiple parties, or coordination across departments. Multi-agent systems handle this by assigning each stage to a purpose-built agent, with defined handoff points and escalation paths.\n\nWe've built multi-agent pipelines for document processing chains, risk assessment workflows, and operational coordination systems. The architecture is designed so each agent is testable and auditable independently."
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ProfessionalService",
                            name: "AI Agent Deployment & Analytics Consulting — Enterprise India",
                            url: "https://www.itmtb.com/services/analytics-ai-automation",
                            image: "https://www.itmtb.com/services/capability/data.webp",
                            description: "ITMTB deploys AI agents for enterprise operations — analytics, automation, and agentic AI built for production. Enterprise AI deployment partner.",
                            provider: {
                                "@type": "Organization",
                                name: "ITMTB Technologies",
                                url: "https://www.itmtb.com",
                                logo: "https://www.itmtb.com/logo.webp"
                            },
                            areaServed: [
                                {
                                    "@type": "Place",
                                    name: "India"
                                }
                            ],
                            serviceType: [
                                "AI Agent Deployment",
                                "Enterprise AI Consulting",
                                "Agentic AI Implementation",
                                "AI Automation Services",
                                "Analytics Consulting",
                                "LLM Deployment Enterprise",
                                "Machine Learning Solutions",
                                "Intelligent Automation", 
                            ],
                            sameAs: [
                                "https://www.linkedin.com/company/itmtb-technologies/",
                                "https://x.com/ITMTBTech",
                                "https://www.instagram.com/itmtbtech/", 
                            ]
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Service2/* default */.Z, {
                heading: "AI Agents for Enterprise Operations",
                paragraph: "Your team spends hours on decisions and tasks that follow predictable rules — reviewing documents, chasing approvals, matching records, generating reports. AI agents can run these workflows autonomously, acting on your data and escalating only when a human genuinely needs to decide.\n\nWe've delivered this in production: a 99% efficiency gain for a global supply chain firm, and fully automated risk reporting for a global intelligence firm — replacing hours of analyst work per report.\n\nITMTB builds the full stack — scoping what's worth automating, building production-grade AI agents, deploying into your environment, and operating post-launch.",
                bgPath: "/services/capability/data.webp",
                primaryCta: {
                    label: "Talk to us →",
                    href: "/contact-us"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessStoryEmbed/* default */.Z, {
                referTag: "Data and Artificial Intelligence",
                maxItems: 3,
                heading: "Selected work in AI & automation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "px-8 md:px-[60px] py-8 bg-white border-t border-gray-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "max-w-4xl text-sm text-gray-500 leading-relaxed",
                        children: [
                            "For regulated document workflows, see how we designed a",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog/pharma-compliance-ai-sop-bmr-warning-letter-review",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                    children: "pharma compliance AI platform for SOP, BMR, and warning-letter review"
                                })
                            }),
                            " ",
                            "with traceable findings and human review built into the process."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "max-w-4xl text-sm text-gray-500 leading-relaxed mt-3",
                        children: [
                            "Before an assistant or agent can reason over your content, it has to retrieve it. See what we found testing",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog/enterprise-search-real-world-queries",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                    children: "enterprise search against real-world queries"
                                })
                            }),
                            " ",
                            "in a catalogue where more than half of all searches were returning nothing."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "max-w-4xl text-sm text-gray-500 leading-relaxed mt-3",
                        children: [
                            "Need one difficult use case taken all the way to production? Our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/services/forward-deployed-engineering",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                    children: "forward deployed engineering"
                                })
                            }),
                            " ",
                            "model embeds a senior pod with your team — from workflow discovery to secure deployment — and starts with a fixed-scope AI Deployment Readiness Sprint."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSection/* CustomerSection */.a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrchestriкSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodologyAnchor/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_to_consumable_array/* default */.Z)(caseStudies).concat((0,_to_consumable_array/* default */.Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceFAQ/* default */.Z, {
                items: faqItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceEngagementLinks/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsHome, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}
/* harmony default export */ var analytics_ai_automation = (Analyticsaiautomation);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(1761); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);